import axios from "axios";
import {
  getTokenNoFid,
  checkAccountLogin,
  checkCloudAccountLogin,
} from "api/api";
import store from "../store/";
import { REQUEST_URL, APP_KEY } from "const";

export const checkIamToken = () =>
  new Promise((resolve, reject) => {
    const request =
      store.state.user?.accessTokenType === "cloud"
        ? checkCloudAccountLogin
        : checkAccountLogin;
    request(null, {
      headers: {
        Authorization: `Bearer ${store.state.user.accessToken}`,
      },
    })
      .then((res) => {
        if (res.code === 0) return resolve();
        reject();
      })
      .catch(() => {
        reject();
      });
  });

export const checkToken = () => {
  if (localStorage.getItem("loginType") === "iam") return;
  return new Promise(async (resolve, reject) => {
    if (
      !localStorage.getItem("token") ||
      !JSON.parse(localStorage.getItem("token")).token ||
      Number(JSON.parse(localStorage.getItem("token")).expireTime) <
        Number(new Date().getTime())
    ) {
      const service = axios.create({
        withCredentials: true,
        headers: {
          appKey: APP_KEY,
        },
      });
      const url =
        process.env.NODE_ENV === "development"
          ? `/api/user/getUserInfo?v=${Math.random()}`
          : `${REQUEST_URL}/user/getUserInfo?v=${Math.random()}`;
      // 先判断是否为登录态
      const userInfo = await service.get(url);
      if (!userInfo.data || userInfo.data.code !== 0) reject();
      // 重新获取token
      try {
        localStorage.removeItem("token");
        const tokenRes = await getTokenNoFid();
        if (tokenRes.code === 0) {
          localStorage.setItem(
            "token",
            JSON.stringify({
              token: tokenRes.data.token,
              expireTime:
                new Date().getTime() +
                tokenRes.data.expireTime * 1000 -
                300 * 1000,
            })
          );
          resolve();
        } else {
          reject();
        }
      } catch (msg) {
        reject();
      }
    } else {
      resolve();
    }
  });
};
